import { FieldValues, UseFormHandleSubmit } from "react-hook-form";

interface FormLayoutProps<T extends FieldValues, TTransformed = T> {
  children: React.ReactNode;
  handleSubmit?: UseFormHandleSubmit<T, TTransformed>;
  onSubmit?: (data: TTransformed) => Promise<void>;
}

export function FormLayout<T extends FieldValues, TTransformed = T>({
  children,
  handleSubmit,
  onSubmit,
}: FormLayoutProps<T, TTransformed>) {
  const handleSubmitForm =
    handleSubmit && onSubmit ? handleSubmit(onSubmit) : undefined;

  return (
    <form
      className="flex w-full gap-4 md:gap-6 flex-col"
      onSubmit={handleSubmitForm}
    >
      {children}
    </form>
  );
}
